import React, { useEffect, useMemo, useState } from "react";
import { StyleSheet, View, ScrollView } from "react-native";
import { IError } from "src/components/dialog/error";
import { Container, Input, Button, Typography } from "src/components";
import { useForm } from "react-hook-form";
import * as formValidators from "src/utils/form-validator";
import { Auth } from "aws-amplify";
import { colors } from "src/assets";
import { CognitoUser } from "amazon-cognito-identity-js";
import { updateCognitoEmailEventEmit } from "src/utils/event";
import LocalText from "src/local";

type FormValues = {
  email: string;
};

export type RequestProps = {
  onDone: (email: string) => void;
};

export const Request: React.FC<RequestProps> = (props) => {
  const {
    register,
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<FormValues>({
    defaultValues: { email: "" },
  });
  const [error, setError] = useState<IError | null>(null);
  const [processed, setProcessed] = useState<boolean>(false);
  const [cognitoUser, setCognitoUser] = useState<CognitoUser | undefined>();
  const [cognitoUserAttributes, setCognitoUserAttributes] = useState<any>({});

  useEffect(() => {
    Auth.currentAuthenticatedUser().then((user) => {
      setCognitoUser(user);
      setCognitoUserAttributes(user.attributes);
      setValue("email", user.attributes.email);
    });
  }, [setValue]);
  useEffect(() => {
    register("email", {
      validate: (value) => {
        if (!formValidators.RequireValidator(value)) {
          return LocalText.screens.myAccountEmail.request
            .emailValidationRequire;
        }
        if (!formValidators.EmailValidator(value)) {
          return LocalText.screens.myAccountEmail.request.emailValidationFormat;
        }
        if (cognitoUserAttributes.email === value) {
          return LocalText.screens.myAccountEmail.request.emailValidationMatch;
        }
        return true;
      },
    });
  }, [register, cognitoUserAttributes.email]);
  const onConfirm = async (data: FormValues) => {
    if (!cognitoUser) {
      return;
    }
    setProcessed(true);
    try {
      await Auth.updateUserAttributes(cognitoUser, {
        email: data.email,
      });
      updateCognitoEmailEventEmit();
      setProcessed(false);
      props.onDone(data.email);
    } catch (e) {
      // e "AliasExistsException"
      console.log(
        "ddd",
        (e as Error).code,
        (e as Error).name,
        (e as Error).message
      );
      console.log(e);
      setError(e as Error);
      setProcessed(false);
    }
  };
  const errorMessage = useMemo(() => {
    if (error?.code === "AliasExistsException") {
      return LocalText.error.amplifyAuthUsernameExistsException;
    }
    return error?.code;
  }, [error]);
  return (
    <Container style={styles.container} loading={processed}>
      <ScrollView style={styles.scrollView}>
        <Typography
          text={LocalText.screens.myAccountEmail.request.email}
          variant={"section"}
        />
        <Input
          placeholder={LocalText.screens.myAccountEmail.request.email}
          name={"email"}
          control={control}
          autoCapitalize={"none"}
          error={errors.email?.message || errorMessage}
          keyboardType={"email-address"}
        />
        <Typography
          text={LocalText.screens.myAccountEmail.request.emailDescription}
          variant={"section"}
        />

        <View style={styles.buttonContainer}>
          <Button
            title={LocalText.common.next}
            loading={processed}
            onPress={handleSubmit(onConfirm)}
          />
        </View>
      </ScrollView>
    </Container>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "column",
    backgroundColor: colors.gray1,
  },
  scrollView: {
    flex: 1,
  },
  buttonContainer: {
    flexDirection: "column",
    marginTop: 36,
    marginHorizontal: 16,
  },
});
